// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-QlS","label":"styles_label__2Cd0T"};